import { FaIcon } from "@zeguro/component-library"
import { colors } from "@src/theme"
import styled from "styled-components"

interface IOval {
  color: string
}

export const Oval = styled.div<IOval>`
  width: 16px;
  height: 16px;
  margin-right: 10px;
  background-color: ${({ color }) => color || "#ff002a"};
  border-radius: 8px;
`

export const BoxBody = styled.div`
  width: 100%;
  font-family: proxima-nova, sans-serif;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: normal;
`
export const IssueSeverityContainer = styled.div`
  min-height: 30px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  @media (min-width: 901px) and (max-width: 985px) {
    display: grid;
    grid-template-columns: max-content max-content;
    align-items: center;
    column-gap: 12px;
    row-gap: 10px;
  }
  @media (max-width: 624px) {
    display: grid;
    grid-template-columns: max-content max-content;
    align-items: center;
    column-gap: 12px;
    row-gap: 10px;
  }
`
export const IssuesText = styled.p`
  font-weight: 600;
  font-size: 21px;
  font-family: montserrat;
  margin-right: 16px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: ${colors.darkBlue};
`
export const IssueContainer = styled.div`
  min-height: 30px;
  width: 100%;
  font-family: proxima-nova, sans-serif;
  display: flex;
  @media (max-width: 1071px) {
    flex-direction: column;
  }
`
export const ScanInfoContainer = styled.div`
  padding: 20px 0 0 0;
  margin-top: 30px;
  border-top: 1px solid ${colors.gray5};
  a {
    text-decoration: none;
  }
`
export const ScanInfoContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 215px;
  margin-top: 20px;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px 0;
  }
`
export const ScanInfoElement = styled.div<{ align?: string }>`
  display: flex;
  justify-content: center;
  align-items: ${({ align }) => align || "center"};
  flex-direction: column;
`
export const ScanInfoElementText = styled.p<{ color?: string }>`
  font-size: 16px;
  color: ${({ color }) => color || colors.darkBlue};
  margin-top: 5px;
  text-align: center;
`
export const CollapseArrow = styled(FaIcon)<{ showMore: boolean }>`
  transition: transform 333ms ease-out;
  transform: ${({ showMore }) => showMore && "rotate(180deg)"};
`
export const DownloadRow = styled.div<{ justifyContent?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent || "flex-start"};
  #scan-tables-download-report-btn {
    padding: 0 10px;
    i {
      margin: 0 3px;
    }
  }
`
export const PopoverDownloadContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  line-height: 24px;
`
export const DownloadHeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  font-family: proxima-nova, sans-serif;
  padding: 0 0 13px 0;
  @media (max-width: 625px) {
    justify-content: start;
  }
  @media (max-width: 320px) {
    padding: 0 13px 13px 13px;
  }
`
export const Issue = styled.div<{ opacity?: number }>`
  width: 25%;
  padding: 0 15px;
  min-height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 130px;
  &:not(:last-child) {
    @media (min-width: 625px) {
      border-right: 1px solid ${colors.gray5};
    }
    @media (min-width: 901px) and (max-width: 985px) {
      border-right: none;
    }
  }
  @media (min-width: 901px) and (max-width: 985px) {
    display: contents;
  }
  @media (max-width: 624px) {
    display: contents;
  }
`

export const IssueCount = styled.div`
  font-family: proxima-nova, sans-serif;
  font-size: 28px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #212528;
  @media (min-width: 901px) and (max-width: 985px) {
    justify-content: flex-end;
  }
  @media (max-width: 624px) {
    justify-content: flex-end;
  }
`

export const IssueSeverity = styled.div`
  font-family: proxima-nova, sans-serif;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #212528;
  @media (min-width: 901px) and (max-width: 985px) {
    justify-content: flex-start;
  }
  @media (max-width: 624px) {
    justify-content: flex-start;
  }
`

export const SuperScript = styled.sup`
  font-size: 16px;
  position: relative;
  top: -5px;
  line-height: 0;
`

export const PopoverContent = styled.div`
  padding: 10px 16px;
  max-width: 350px;
  font-size: 16px;
  line-height: 21px;
  font-family: proxima-nova, sans-serif;
  a {
    color: ${colors.white};
    &:hover {
      color: ${colors.white};
    }
  }
`
